import { FC } from "react";
import { useSelector } from "react-redux";

import { bandSettingsSelector } from "Bands/state";
import { IBaseBandSetting } from "Bands/types";
import { copy } from "shared/assets";
import { Card } from "shared/components";
import { IDataKeys } from "shared/types";
import { EditTable } from "../components";

const settingsCopy = copy.bandSettings.eventSettings.ticketAndPass;

export const EditEventTicketAndPass: FC = () => {
  const initialItems = useSelector(
    bandSettingsSelector<IBaseBandSetting>(IDataKeys.eventTicketAndPassTypes)
  );

  return (
    <Card title={settingsCopy.edit}>
      <EditTable
        name="eventTicketAndPass"
        initialItems={initialItems}
        hasDragAndDrop={true}
        hasIcon={false}
        addCopy={settingsCopy.add}
        dataKey={IDataKeys.eventTicketAndPassTypes}
        modalTitle={settingsCopy.modalTitle}
        modalMessage={settingsCopy.modalMessage}
      />
    </Card>
  );
};
